import React, { Component } from 'react';
import Big from 'big.js';
import { Title, Input, Error } from 'library';
import styles from './styles';
import { css } from 'aphrodite';

class GroutJointSize extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isImperialSystem: this.props.isImperialSystem,
            isError: this.props.isError,
            widthError: true,
            depthError: true,
            jointWidth: "",
            jointDepth: "",
            calculationJointWidth: "",
            calculationJointDepth: ""
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isImperialSystem !== this.props.isImperialSystem) {
            this.setState({isImperialSystem: this.props.isImperialSystem});
        }
        if(prevProps.isError !== this.props.isError) {
            this.setState({isError: this.props.isError},()=>{
                if(this.state.jointWidth === "") this.setState({widthError: true});
                if(this.state.jointDepth === "") this.setState({depthError: true});
            });
        }
    }

    checkCharacter(value, calculationValue) {
        // Checks if there is a fraction in the input
        // 'value' is the value to display in the input with possible fraction for user readability
        // 'calculationValue' is the value converted to number for calculation only

        var valueSplitted;

        if (value.indexOf('/') > -1) {
            valueSplitted = value.split('/')
            value = valueSplitted[0] + '/' + valueSplitted[1]

            if (valueSplitted[1] === '' || valueSplitted[1] == 0) {
                calculationValue = valueSplitted[0]
            } else {
                calculationValue = new Big(valueSplitted[0]).div(new Big(valueSplitted[1]))
            }
        } else if (value.indexOf(',') > -1) {
            valueSplitted = value.split(',')
            value = valueSplitted[0] + '.' + valueSplitted[1]
            calculationValue =  value
        } else {
            calculationValue =  value
        }

        return { value, calculationValue }
    }

    updateInputs(e) {
        var value = e.target.value;
        switch (e.target.id) {
            case "jointWidth":
                var { value, calculationValue } = this.checkCharacter(value, calculationValue);

                // Update input value
                this.setState({jointWidth: value})

                if(value.length > 0 || typeof value === 'number') {
                    this.setState({calculationJointWidth: calculationValue, widthError: false}, () => {
                        this.checkValidity();
                    });
                } else {
                    this.setState({calculationJointWidth: calculationValue, widthError: true}, () => {
                        this.checkValidity();
                    });
                }
                break;
            case "jointDepth":
                var { value, calculationValue } = this.checkCharacter(value, calculationValue);

                // Update input value
                this.setState({jointDepth: value})

                if(value.length > 0 || typeof value === 'number') {
                    this.setState({calculationJointDepth: calculationValue, depthError: calculationValue === ""}, () => {
                        this.checkValidity();
                    });
                } else {
                    this.setState({calculationJointDepth: calculationValue, depthError: true}, () => {
                        this.checkValidity();
                    });
                }
                break;
            default:
                break;
        }
    }

    checkValidity() {
        if (!this.state.depthError && !this.state.widthError) {
            this.props.onJointDimensionsEntered({
                jointWidth: this.state.calculationJointWidth,
                jointDepth: this.state.calculationJointDepth
            });
        } else {
            this.props.onJointDimensionsEntered(null);
        }
    }

    render() {
        const { title, paragraph, widthLabel, depthLabel, widthDescription, depthDescription, errorLabel, groutJointImage } = this.props;

        return (
            <div className={css(styles.groutJointSize)}>
                <div className={css(styles.wrapper)}>
                    <Title style={styles.h3}>{title}</Title>

                    <div className={css(styles.groutJointSizeContent, this.state.isError && styles.contentError)}>
                        <div className={css(styles.groutJointSizeText)}>
                            <div className={css(styles.paragraph)} dangerouslySetInnerHTML={{__html: paragraph}}></div>
                            <div className={css(styles.inputsRegion)}>
                                <Input
                                    id="jointWidth"
                                    label={widthLabel}
                                    isImperialSystem={this.state.isImperialSystem}
                                    small
                                    description={widthDescription}
                                    onChange={(e)=>this.updateInputs(e)}
                                    value={this.state.jointWidth}
                                    isError={this.state.isError && this.state.widthError}
                                    isPrintable
                                />
                                <Input
                                    id="jointDepth"
                                    label={depthLabel}
                                    isImperialSystem={this.state.isImperialSystem}
                                    small
                                    operator="×"
                                    description={depthDescription}
                                    onChange={(e)=>this.updateInputs(e)}
                                    value={this.state.jointDepth}
                                    isError={this.state.isError && this.state.depthError}
                                    isPrintable
                                />
                            </div>
                        </div>
                        <figure className={css(styles.figure)}>
                            <img className={css(styles.image)} src={groutJointImage} alt="" />
                        </figure>
                    </div>

                </div>
                {this.state.isError &&
                <div className={css(styles.error)}>
                    <Error label={errorLabel}/>
                </div>
                }
            </div>
        );
    }
}

export default GroutJointSize;